import { useSearchParams } from 'react-router-dom';

export const useAppSearchParams = () => {
  const [searchParams] = useSearchParams();

  const pickemId = Number(searchParams.get('pickem_id') ?? '');
  const questionId = Number(searchParams.get('question_id') ?? '');
  const leagueId = Number(searchParams.get('league_id') ?? 0);
  const tournamentId = Number(searchParams.get('tournament_id') ?? 0);
  const pageId = Number(searchParams.get('page_id') ?? 0);
  const userId = Number(searchParams.get('user_id') ?? '');

  return {
    pickemId,
    questionId,
    leagueId,
    tournamentId,
    pageId,
    userId,
  };
};
